// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { api } from '../../api/client';

// const TOKEN_KEY = 'auth_token';
// const FORCE_PW_KEY = 'forcePasswordChange';
// sessionStorage.removeItem(TOKEN_KEY);

// // ─── JWT decoder ──────────────────────────────────────────────────────────────
// const decodeToken = (token) => {
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         return JSON.parse(window.atob(base64));
//     } catch {
//         return null;
//     }
// };

// // ─── Thunks ───────────────────────────────────────────────────────────────────
// export const login = createAsyncThunk(
//     'auth/login',
//     async ({ username, password }, { rejectWithValue }) => {
//         try {
//             const res = await api.post('/auth/login', { username, password });
//             return res.data;
//         } catch (err) {
//             return rejectWithValue(err.response?.data || { message: 'Login failed' });
//         }
//     }
// );

// export const changePassword = createAsyncThunk(
//     'auth/changePassword',
//     async ({ userId, oldPassword, newPassword }, { rejectWithValue }) => {
//         try {
//             const res = await api.post('/auth/change-password', { userId, oldPassword, newPassword });
//             return res.data;
//         } catch (err) {
//             return rejectWithValue(err.response?.data || { message: 'Change password failed' });
//         }
//     }
// );




// // ─── Default empty state ──────────────────────────────────────────────────────
// const emptyState = () => ({
//     authenticated: false,
//     token: null,
//     username: null,
//     userId: null,
//     roles: [],
//     forcePasswordChange: false,
//     loading: false,
//     error: null,
//       sessionMessage: null
// });


// const initializeAuthState = () => {
//     if (typeof window === 'undefined') return emptyState(); // SSR safety

//     const token = localStorage.getItem(TOKEN_KEY);
//     if (!token) return emptyState(); // no token → login screen

//     const decoded = decodeToken(token);
//     if (!decoded) {

//         localStorage.removeItem(TOKEN_KEY);
//         localStorage.removeItem(FORCE_PW_KEY);
//         return emptyState();
//     }

//     const forcePasswordChange = localStorage.getItem(FORCE_PW_KEY) === 'true';

//     return {

//         authenticated: !forcePasswordChange,  
//         token,
//         username: decoded.sub || null,
//         userId: decoded.userId || null,
//         roles: decoded.roles || [],
//         forcePasswordChange,
//         loading: false,
//         error: null,
//     };
// };

// const initialState = initializeAuthState();

// // ─── Slice ────────────────────────────────────────────────────────────────────
// const authSlice = createSlice({
//     name: 'auth',
//     initialState,

   
//     reducers: {
//         logout(state) {

//             Object.assign(state, emptyState());
//             localStorage.removeItem(TOKEN_KEY);
//             localStorage.removeItem(FORCE_PW_KEY);
//         },

//             sessionExpired(state) {
//         Object.assign(state, emptyState());
//         localStorage.removeItem(TOKEN_KEY);
//         localStorage.removeItem(FORCE_PW_KEY);
//     },
//     },

//     extraReducers: (builder) => {
//         builder
//             // ── LOGIN ──────────────────────────────────────────────────────────
//             .addCase(login.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(login.fulfilled, (state, action) => {
//                 state.loading = false;

//                 const token = action.payload.token;
//                 if (!token) {
                
//                     state.error = 'No token received';
//                     return;
//                 }

//                 const decoded = decodeToken(token);
//                 state.token = token;
//                 state.userId = decoded?.userId || null;
//                 state.username = decoded?.sub || null;
//                 state.roles = decoded?.roles || [];

//                 const forceChange = !!action.payload.forcePasswordChange;
//                 state.forcePasswordChange = forceChange;

//                 state.authenticated = !forceChange;

//                 localStorage.setItem(TOKEN_KEY, token);

//                 if (forceChange) {
//                     localStorage.setItem(FORCE_PW_KEY, 'true');
//                 } else {
//                     localStorage.removeItem(FORCE_PW_KEY);
//                 }
//             })
//             .addCase(login.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload?.message || 'Login failed';
//             })

//             // ── CHANGE PASSWORD ────────────────────────────────────────────────
//             .addCase(changePassword.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(changePassword.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.forcePasswordChange = false;
//                 state.authenticated = true;  

              
//                 if (action.payload?.token) {
//                     const newToken = action.payload.token;
//                     const decoded = decodeToken(newToken);
//                     state.token = newToken;
//                     state.userId = decoded?.userId || state.userId;
//                     state.username = decoded?.sub || state.username;
//                     state.roles = decoded?.roles || state.roles;
//                     localStorage.setItem(TOKEN_KEY, newToken);
//                 }

//                 localStorage.removeItem(FORCE_PW_KEY); 
//             })
//             .addCase(changePassword.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload?.message || 'Change password failed';
//             });
//     },
// });

// export const { logout } = authSlice.actions;
// export default authSlice.reducer;
// store/slices/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';

const TOKEN_KEY = 'auth_token';
const FORCE_PW_KEY = 'forcePasswordChange';

// ─── JWT Decoder ─────────────────────────────────────────────────────────────
const decodeToken = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
    } catch (e) {
        console.error('Token decode failed:', e);
        return null;
    }
};

// ─── Thunks ──────────────────────────────────────────────────────────────────
export const login = createAsyncThunk(
    'auth/login',
    async ({ username, password }, { rejectWithValue }) => {
        try {
            const res = await api.post('/auth/login', { username, password });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { message: 'Login failed' });
        }
    }
);

export const changePassword = createAsyncThunk(
    'auth/changePassword',
    async ({ oldPassword, newPassword }, { rejectWithValue, getState }) => {
        const userId = getState().auth.userId;
        if (!userId) throw new Error('User ID not found');

        try {
            const res = await api.post('/auth/change-password', {
                userId,
                oldPassword,
                newPassword,
            });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || { message: 'Change password failed' });
        }
    }
);

// ─── Initial State ───────────────────────────────────────────────────────────
const getInitialState = () => {
    if (typeof window === 'undefined') {
        return {
            authenticated: false,
            token: null,
            username: null,
            userId: null,
            roles: [],
            forcePasswordChange: false,
            loading: false,
            error: null,
            sessionMessage: null,
        };
    }

    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return getEmptyState();

    const decoded = decodeToken(token);
    if (!decoded) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(FORCE_PW_KEY);
        return getEmptyState();
    }

    const forcePasswordChange = localStorage.getItem(FORCE_PW_KEY) === 'true';

    return {
        authenticated: !forcePasswordChange,
        token,
        username: decoded.sub || null,
        userId: decoded.userId || null,
        roles: decoded.roles || [],
        forcePasswordChange,
        loading: false,
        error: null,
        sessionMessage: null,
    };
};

const getEmptyState = () => ({
    authenticated: false,
    token: null,
    username: null,
    userId: null,
    roles: [],
    forcePasswordChange: false,
    loading: false,
    error: null,
    sessionMessage: null,
});

const initialState = getInitialState();

// ─── Slice ───────────────────────────────────────────────────────────────────
const authSlice = createSlice({
    name: 'auth',
    initialState,

    reducers: {
        logout(state) {
            Object.assign(state, getEmptyState());
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(FORCE_PW_KEY);
        },

        sessionExpired(state) {
            Object.assign(state, getEmptyState());
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(FORCE_PW_KEY);
            state.sessionMessage = 'You have been logged out. Another device logged into your account.';
        },

        clearError(state) {
            state.error = null;
        },

        clearSessionMessage(state) {
            state.sessionMessage = null;
        },
    },

    extraReducers: (builder) => {
        builder
            // LOGIN
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                  console.log('Login Response:', action.payload);
                const { token, forcePasswordChange = false } = action.payload;

                if (!token) {
                    state.error = 'No token received from server';
                    return;
                }

                const decoded = decodeToken(token);
                if (!decoded) {
                    state.error = 'Invalid token received';
                    return;
                }

                state.token = token;
                state.userId = decoded.userId || null;
                state.username = decoded.sub || null;
                state.roles = decoded.roles || [];
                state.forcePasswordChange = forcePasswordChange;
                state.authenticated = !forcePasswordChange;
                state.error = null;
                state.sessionMessage = null;

                localStorage.setItem(TOKEN_KEY, token);

                if (forcePasswordChange) {
                    localStorage.setItem(FORCE_PW_KEY, 'true');
                } else {
                    localStorage.removeItem(FORCE_PW_KEY);
                }
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Login failed';
            })

            // CHANGE PASSWORD
            .addCase(changePassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(changePassword.fulfilled, (state, action) => {
                state.loading = false;
                state.forcePasswordChange = false;
                state.authenticated = true;
                state.error = null;

                // Update token if server returns new one
                if (action.payload?.token) {
                    const newToken = action.payload.token;
                    const decoded = decodeToken(newToken);

                    state.token = newToken;
                    state.userId = decoded?.userId || state.userId;
                    state.username = decoded?.sub || state.username;
                    state.roles = decoded?.roles || state.roles;

                    localStorage.setItem(TOKEN_KEY, newToken);
                }

                localStorage.removeItem(FORCE_PW_KEY);
            })
            .addCase(changePassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Change password failed';
            });
    },
});

export const { logout, sessionExpired, clearError, clearSessionMessage } = authSlice.actions;
export default authSlice.reducer;
